import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { Input } from "antd";
import { CustomCalendar, SelectBox, SelectBoxItem } from "../../../../components";
import { SearchBlack } from "../../../../components/Icons/Icons";
import { checkRoleSupAdmin, formatDB } from "../../../../utils";
import { companyFSR } from "../../../../services/api/companyFSR";
import { departmentFSR } from "../../../../services/api/departmentFSR";

const cx = classNames.bind(styles);
const Filter = ({
  value,
  onChange,
  dateHaveEvent
}) => {
  const handleChangeFilter = (key, value) => {
    onChange(key, value)
  }
  const [listCompanies, setListCompanies] = useState([])
  const [listDepartment, setListDepartment] = useState([])
  // const getListCompany = async () => {
  //   try {
  //     const res = await companyFSR.get();
  //     if (res) {
  //       const companies = res?.map(item => {
  //         return {
  //           value: item?.CODE,
  //           label: item?.NAME
  //         }
  //       })
  //       setListCompanies(companies)
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //   }
  // }
  const getListDepartment = async (company) => {
    try {
      const param = {
        page: 1,
        limit: 1000,
        organization_code: company
      }
      const res = await departmentFSR.get(param)
      if (res && res?.data) {
        const departments = res?.data?.map(item => {
          return {
            value: item?.id,
            label: item?.name
          }
        })
        setListDepartment(departments)
      }
    } catch (error) {
      // console.log(error);
    }
  }
  // useEffect(() => {
  //   if (checkRoleSupAdmin()) {
  //     getListCompany()
  //   }
  // }, [])
  useEffect(() => {
    // if (value?.organizationCode) {
    getListDepartment(value?.organizationCode)
    // }
  }, [value?.organizationCode])
  return (
    <div className={cx("filter")}>
      <div className={cx('count-number')}>
        <p className={cx('label')}></p>
        <Input
          className={cx('number-image')}
          placeholder="Tên nhân viên"
          value={value?.nameEmployee}
          onChange={(e) => handleChangeFilter('nameEmployee', e.target.value)}
          prefix={<SearchBlack />}
        />
      </div>
      {/* {sessionStorage.getItem("company_code") === "DEFAULT" && (
        <SelectBox
          type="small"
          title={'Đơn vị'}
          className={cx('select')}
          onChange={(e) => handleChangeFilter('organizationCode', e)}
        >
          <SelectBoxItem label={"Tất cả"} value={null} />
          {
            listCompanies?.length > 0 ? listCompanies?.map(item => {
              return <SelectBoxItem key={item?.value} label={item?.label} value={item?.value} />
            }) : <></>
          }
        </SelectBox>
      )} */}
      <SelectBox
        type="small"
        title={'Phòng ban'}
        className={cx('select')}
        onChange={(e) => handleChangeFilter('department', e)}
      >
        <SelectBoxItem label={"Tất cả"} value={null} />
        <SelectBoxItem label={"Không rõ"} value={"none"} />
        {
          listDepartment?.length > 0 ? listDepartment?.map(item => {
            return <SelectBoxItem key={item?.value} label={item?.label} value={item?.value} />
          }) : <></>
        }
      </SelectBox>
      <div style={{ flex: 1, marginTop: -7, maxWidth: 300 }}>
        {/* dayH1 là các ngày có sự kiện */}
        <CustomCalendar value={value?.timeStart} title={'Bắt đầu'} onChange={(e) => handleChangeFilter('timeStart', e)} dayHl={dateHaveEvent} />
      </div>
      <div style={{ flex: 1, marginTop: -7, maxWidth: 300 }}>
        <CustomCalendar value={value?.timeEnd} title={'Kết thúc'} onChange={(e) => handleChangeFilter('timeEnd', e)} dayHl={dateHaveEvent} />
      </div>
    </div>
  );
};

export default Filter;
